import { useState } from "react";
import { Button } from "antd";
import { LeftOutlined, RightOutlined, LinkOutlined, ExportOutlined } from "@ant-design/icons";
import "./AppDemo.css";

const AppDemo = ({ app, onBack }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const demo = app.demo_content[currentIndex];

  return (
    <div className="app-demo">
      <header className="modal-header app-demo-header">
        <Button onClick={onBack}>← Back</Button>
        <h3 className="demo-app-name">{app.name}</h3>
      </header>

      <div className="demo-carousel">
        <Button
          icon={<LeftOutlined />}
          onClick={() => setCurrentIndex(i => i - 1)}
          disabled={currentIndex === 0}
        />

        <div className="demo-item">
          {demo.image && (<img src={demo.image} alt="" />)}
          <span>
            {app.redirect_link &&
              (
                <a
                  href={app.redirect_link}
                  target="_blank"
                  rel="noreferrer"
                  className="external-link"
                >
                  View it Here
                  <ExportOutlined className="demo-app-redirect-icon" />
                </a>
              )}
          </span>
          <p>{demo.description}</p>
        </div>

        <Button
          icon={<RightOutlined />}
          onClick={() => setCurrentIndex(i => i + 1)}
          disabled={currentIndex === app.demo_content.length - 1}
        />
      </div>

      <div className="demo-indicator">
        {currentIndex + 1} / {app.demo_content.length}
      </div>
    </div>
  );
};

export default AppDemo;
